module.exports = __webpack_public_path__ + "media/configurations/O-X-X-O-acb0280c.png";